export class MarkerFactory {
    static spritePath = '/statimg/icons/typeSprite2.png';

    static createLegacyStyleAdvancedMarker(map, options) {
        let x = 0, y = 0, id = null;
        let lat, lng;
        let title = "";

        if(options.type === 'document') {
            const categoryId = options.categoryId;
            const rotation = options.rotation;

            x = 27 * 2 * (categoryId - 1); // 2x wegen Normal/Hover
            y = rotation ? (Math.round(rotation / (360 / 8)) + 1) * 27: 0;
        } else if(options.type === 'archive') {
            title = options.title;
            x = 432;
            y = 0;
        } else if(options.type === 'cluster') {
            x = 324;
            y = 0;
        } else {
            console.warn("[MarkerFactory] Unknown markerData format: ", options);
            return null;
        }
        lat = options.position.lat();
        lng = options.position.lng();
        
        const div = document.createElement('div');
        div.style.width = "26px";
        div.style.height = "26px";
        div.style.backgroundImage = `url('${this.spritePath}')`;
        div.style.backgroundPosition = `-${x}px -${y}px`;
        div.style.backgroundSize = "auto"; // Sprite-Handling
        div.style.imageRendering = "auto"; // optional: klarere Kanten bei Skaling
        div.className = "legacyStyleMarker";
        div.dataset.x = x;
        div.dataset.y = y;
        div.dataset.rotation = options.rotation;

        const marker = new google.maps.marker.AdvancedMarkerElement({
           map: map,
           position: new google.maps.LatLng(lat, lng),
           title: title,
           content: div,
           gmpClickable: true
        });
        return marker;
    }

    static createAdvancedMarker(options) {
        return new google.maps.marker.AdvancedMarkerElement(options);
    }

    static GetDocumentMarkerImage(marker) {
        let icon = marker.getIcon();
        return new google.maps.MarkerImage(icon.url, icon.size, new google.maps.Point(marker.IconOrigin.x, marker.IconOrigin.y))
    }

    static setRotatedState(marker){
        if(!marker?.content || !marker.content.dataset) { return; }

        const rotation = parseInt(marker.content.dataset.rotation || 0, 10);
        const x = parseInt(marker.content.dataset.x || 0, 10);

        let heading = 0;
        try {
            heading = marker.map.getHeading();
        } catch (error) {
            console.debug('[MarkerFactory] setRotatedState: getHeading() failed,', error);
        }

        const rotIndex = this.rotateIcon(rotation, heading);
        const y = (rotIndex + 1) * 27;

        marker.content.style.backgroundPosition = `-${x}px -${y}px`;
    }

    static rotateIcon(rotation, heading) {
        let ipos = Math.round((rotation - heading) % 360 / (360 / 8));
        if (ipos < 0) {
            ipos += 8;
        }
        if (ipos > 8) {
            ipos -= 8;
        }
        return ipos;
    }

    static GetHighlightedDocumentMarkerImage(marker) {
        let icon = marker.getIcon();
        return new google.maps.MarkerImage(icon.url, icon.size, new google.maps.Point(marker.IconOrigin.x + 27, marker.IconOrigin.y));
    }

    static GetHighlightedRotatedDocumentMarkerImage(marker){
        let icon = marker.getIcon();
        let heading = 0;
        try {
            heading = marker.map.getHeading();
        } catch (error) {
            console.debug('Exception getHeading()', error);
        }
        return new google.maps.MarkerImage(icon.url, icon.size, new google.maps.Point(marker.IconOrigin.x + 27, (this.rotateIcon(marker.IconRotation, heading) + 1) * 27))
    }

    static GetArchiveMarkerContent() {
        const archiveMarkerContentContainer = document.createElement("div");
        archiveMarkerContentContainer.className = "archiveMarker";

        return archiveMarkerContentContainer;
    }

    static GetClusterMarkerContent(documentCount) {
        const documentClusterMarkerContentContainer = document.createElement("div");
        documentClusterMarkerContentContainer.className = "documentClusterMarker";

        const clusterLabel = document.createElement("div");
        clusterLabel.className = "label documentClusterMarkerMouse";
        clusterLabel.textContent = documentCount;
        documentClusterMarkerContentContainer.appendChild(clusterLabel);

        return documentClusterMarkerContentContainer;
    }

    static GetDocumentMarkerContent() {
        const documentMarkerContentContainer = document.createElement("div");
        documentMarkerContentContainer.className = "documentMarker";

        return documentMarkerContentContainer;
    }


    /***
     Marker creation related methods
     ***/

    static createArchiveMarker(map, archiveName, latitude, longitude){
        const archiveMarkerContainer = this.GetArchiveMarkerContent();

        const archiveMarker = this.createLegacyStyleAdvancedMarker(map, {
            type: 'archive',
            map: map,
            position: new google.maps.LatLng(latitude, longitude),
            title: `Topothek ${archiveName}`,
            gmpClickable: true,
        });
        return archiveMarker;
    }

    static createDocumentClusterMarker(map, position, documentCount) {
        const clusterMarkerContainer = this.GetClusterMarkerContent(documentCount);

        const documentClusterMarker = this.createLegacyStyleAdvancedMarker(map, {
            type: 'cluster',
            map: map,
            position: new google.maps.LatLng(position.lat(), position.lng()),
            title: "",
            gmpClickable: true,
        });
        const clusterLabelContainer = document.createElement("div");
        clusterLabelContainer.className = "label documentClusterMarkerMouse";
        const clusterLabel = document.createElement("span");
        clusterLabel.textContent = documentCount;
        clusterLabelContainer.appendChild(clusterLabel);
        documentClusterMarker.content.appendChild(clusterLabelContainer);

        return documentClusterMarker;
    }

    static createDocumentMarker(map, markerData){
        const documentMarkerContainer = this.GetDocumentMarkerContent();
        documentMarkerContainer.id = markerData[0];

        let documentMarker = this.createLegacyStyleAdvancedMarker(map, {
            type: 'document',
            categoryId: markerData[4],
            rotation: markerData[5],
            map: map,
            position: new google.maps.LatLng(markerData[1], markerData[2]),
            title: "",
            content: documentMarkerContainer,
            gmpClickable: true
        });
        documentMarker.customId = markerData[0];
        return documentMarker;
    }
}
